import React, { useMemo, useState } from 'react'
import { uniq } from 'lodash'
import { MultiSelectDropdown } from './shared'
import { IChannelsV1List, useArray, varClass } from '../../shared'
import { putRequest } from '../../../services'

export const AllowPpcModal = (props) => {
  const { campaign, hideModal, reloadCampaign, showSnackbar } = props
  // See PrioritizeModal — guard against lazy-trackers race.
  const trackers = campaign.trackers || []
  const [selectedMethod, setSelectedMethod] = useState('')

  const initialSelectedChannels = useMemo(
    () =>
      uniq(
        trackers
          .filter((tracker) => tracker.trackerAllowInternalPpc)
          .map((tracker) => tracker.trackerChannelUuid)
      ),
    [campaign]
  )
  const {
    values: selectedChannels,
    toggle: toggleSelectedChannel,
    clear: clearSelectedChannels,
  } = useArray(initialSelectedChannels)

  const canDisallowAll = useMemo(
    () => !!initialSelectedChannels.length,
    [campaign]
  )

  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const submit = async () => {
    setSubmitting(true)
    setError('')

    let allowPpcCampaignUuids = []
    let disallowPpcCampaignUuids = []

    if (selectedMethod === 'specific') {
      if (selectedChannels.length) {
        allowPpcCampaignUuids = trackers
          .filter((tracker) =>
            selectedChannels.includes(tracker.trackerChannelUuid)
          )
          .map((t) => t.trackerUuid)
      } else {
        allowPpcCampaignUuids = []
      }
    } else if (selectedMethod === 'all') {
      allowPpcCampaignUuids = trackers.map((tracker) => tracker.trackerUuid)
    } else if (selectedMethod === 'none') {
      allowPpcCampaignUuids = []
    }

    for (const tracker of trackers) {
      if (!allowPpcCampaignUuids.includes(tracker.trackerUuid)) {
        disallowPpcCampaignUuids.push(tracker.trackerUuid)
      }
    }

    allowPpcCampaignUuids = allowPpcCampaignUuids.filter((uuid) => uuid)
    disallowPpcCampaignUuids = disallowPpcCampaignUuids.filter((uuid) => uuid)

    const responses = await Promise.all([
      allowPpcCampaignUuids.length
        ? putRequest(`/advs/v2/camps/tracking`, {
            campaignUuids: allowPpcCampaignUuids,
            campaignAllowInternalPpc: true,
          })
        : null,
      disallowPpcCampaignUuids.length
        ? putRequest(`/advs/v2/camps/tracking`, {
            campaignUuids: disallowPpcCampaignUuids,
            campaignAllowInternalPpc: false,
          })
        : null,
    ])

    setSubmitting(false)

    if (responses.every((response) => !response || response.code === 200)) {
      showSnackbar('PPC settings updated')
      reloadCampaign()
      hideModal()
    } else {
      const messages = responses.map((response) => response.message)
      setError(messages.join(', '))
    }
  }

  return (
    <>
      <div className="card-header">
        <div className="card-title row row-space-between">
          Allow PPC traffic
        </div>
      </div>

      <div className="card-body">
        <div
          onChange={(e: any) => setSelectedMethod(e.target.value)}
          className="column column-narrow"
        >
          <div className="control control-radio">
            <input type="radio" name="campaign-priority" value="all" />
            <label>Allow PPC from all sites</label>
          </div>
          {canDisallowAll && (
            <div className="control control-radio">
              <input type="radio" name="campaign-priority" value="none" />
              <label>Disallow PPC from all sites</label>
            </div>
          )}
          <div className="control control-radio">
            <input type="radio" name="campaign-priority" value="specific" />
            <label>Allow PPC from specific sites</label>
          </div>
        </div>

        <div
          className={varClass({
            'subnav-filters w-100 m-t-2': true,
            'disabled': selectedMethod !== 'specific',
          })}
        >
          <MultiSelectDropdown
            label="Sites"
            values={campaign.channels}
            sortKey="channelUuid"
            uuidGetter={(channel: IChannelsV1List) => channel.channelUuid}
            labelGetter={(channel: IChannelsV1List) =>
              channel.channelName || channel.channelDomain
            }
            selectedValues={selectedChannels}
            toggleSelectedValue={toggleSelectedChannel}
            clearSelectedValues={clearSelectedChannels}
          />
        </div>

        <div className="row row-end m-t-5">
          <div className="text-red max-w-50">{error}</div>
          <div className="row">
            <button className="btn btn-bordered m-r-2" onClick={hideModal}>
              Cancel
            </button>
            <button
              className="btn btn-dark"
              disabled={!selectedMethod || submitting}
              onClick={submit}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
